import { render, staticRenderFns } from "./MPortlet.vue?vue&type=template&id=66bcc7ac&"
import script from "./MPortlet.vue?vue&type=script&lang=js&"
export * from "./MPortlet.vue?vue&type=script&lang=js&"
import style0 from "./MPortlet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports